import { useEffect, useState } from "react";
import { TextUpdateMode } from "../../../types/forms";
export var useTextUpdateModeField = function (_a) {
    var _b;
    var field = _a.field, textUpdateMode = _a.textUpdateMode, _c = _a.commitOnEnter, commitOnEnter = _c === void 0 ? true : _c;
    var fieldValue = String((_b = field.value) !== null && _b !== void 0 ? _b : "");
    var _d = useState(fieldValue), localValue = _d[0], setLocalValue = _d[1];
    useEffect(function () {
        setLocalValue(fieldValue);
    }, [fieldValue]);
    if (textUpdateMode === TextUpdateMode.ON_TYPING) {
        return {
            value: fieldValue,
            onChange: function (e) { return field.onChange(e.target.value); },
            onBlur: field.onBlur,
            onKeyDown: function () { },
        };
    }
    var commit = function () {
        if (localValue !== fieldValue) {
            field.onChange(localValue);
        }
    };
    return {
        value: localValue,
        onChange: function (e) { return setLocalValue(e.target.value); },
        onBlur: function () {
            commit();
            field.onBlur();
        },
        onKeyDown: function (e) {
            if (commitOnEnter && e.key === "Enter") {
                commit();
            }
        },
    };
};
